export const config = {
	modules: {
		toolbar: [
			['bold', 'italic', 'underline', 'strike'],
			[{ color: ['#333', '#FFAE00', '#DA2F58', '#1B8043', '#CCCCCC'] }],
			['blockquote'],
			[{ list: 'ordered' }, { list: 'bullet' }],
			['link'],
			[{ script: 'sub' }],
			['clean']
		]
	},
	formats: [
		'bold',
		'italic',
		'underline',
		'strike',
		'color',
		'blockquote',
		'list',
		'link',
		'script'
	]
}
